import {AxiosResponse} from 'axios'
import axiosApi from '../api/axios-api'

export default {
	companyReportSheetTemplateViewByCompanyReportSheet(templateIndex: any, companyReportSheetIdentifier: any, request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreportsheettemplate/view/companyreportsheet/` + templateIndex + `/` + companyReportSheetIdentifier, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	companyReportSheetTemplateViewComments(sheetType: any, companyReportSheetIdentifier: any, templateIndex: any, request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/companyreportsheettemplate/view/comments/` + sheetType + `/` + companyReportSheetIdentifier + `/` + templateIndex, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
	}
}
